module.exports = __webpack_public_path__ + "static/img/dzpk_qzc_banner.3b53e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/dzpk_qzc_banner.png
// module id = d1S8
// module chunks = 0